import { render, staticRenderFns } from "./previewSearchClient.vue?vue&type=template&id=84f9f8a4&scoped=true&"
import script from "./previewSearchClient.vue?vue&type=script&lang=js&"
export * from "./previewSearchClient.vue?vue&type=script&lang=js&"
import style0 from "./previewSearchClient.vue?vue&type=style&index=0&id=84f9f8a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f9f8a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VCard,VDataTable,VSnackbar})
